import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import _ from "lodash";
import { InputLabel, Checkbox } from "@mui/material";
import moment from "moment";
import IconNewRecord from "src/assets/images/icon_newrecord.svg";
import { Search, Close } from "@mui/icons-material";
import { getAllDepotPerson, getByIdDepotPersonal } from "src/thunks/depotUsers";
import { Loader } from "src/components/loader";
import { CommonModal } from "src/components/modal";
import { AddDeportPersonalFrom } from "./component/addDepotPersonal";
import { DeactiveAccountForm } from "./component/deactiveAccountForm";
import { UnlistAccountForm } from "./component/unlistAccountForm";
import { DepotPersonalDetailView } from "./component/detailsView";
import { AllocatToDepo } from "./component/allocaToDepo";
import { GetError } from "src/constant";

export const DepotsPersonal = () => {
  /** redux store useDispatch & useSelector ------------------------------ **/
  const dispatch = useDispatch();
  const { depoPersonel } = useSelector((state) => state.depotUsers);

  /** hooks useState ----------------------------------------------------- **/
  const [searchValue, setSearchValue] = useState("");
  const [open, setOpen] = useState(false);
  const [isAdmin, setisAdmin] = useState(null);
  const [IsActive, setIsActive] = useState(null);
  const [loader, setLoader] = useState(false);
  const [depotPersonalShowData, setDepotPersonalShowData] = useState([]);
  const [showViewRecordButton, setShowViewRecordButton] = useState(false);
  const [isEditFlag, setIsEditFlag] = useState(false);
  const [editTextFlag, setEditTextFlag] = useState(false);
  const [isDeactivatedAccountFlag, setIsDeactivatedAccountFlag] = useState(false);
  const [isUnlistAccountFlag, setIsUnlistAccountFlag] = useState(false);
  const [allocateTogle, setAllocateTogle] = useState(false);
  const [editData, setEditData] = useState({});
  const [selectedRow, setSelectedRow] = useState({});
  const [isDeactivateDepotInfo, setIsDeactivateDepotInfo] = useState({});
  const [isFullDetail, setIsFullDetails] = useState(false);

  /** hooks useEffect----------------------------------------------------- **/

  useEffect(() => {
    getDepoPersonalData();
  }, []);


  useEffect(() => {
    let newData = ManipulatedData();
    if (isAdmin) {
      const filteredAdminObject = newData.filter((d) => d.isAdmin == true);
      setDepotPersonalShowData([...filteredAdminObject]);
    } else if (IsActive) {
      const filteredIsActiveObject = _.filter(
        newData,
        (d1) => d1.isAllocated === false
      );
      setDepotPersonalShowData([...filteredIsActiveObject]);
    } else {
      setDepotPersonalShowData([...newData]);
    }
  }, [depoPersonel, isAdmin, IsActive]);

  /** handler functions--------------------------------------------------- **/

  /** Function to manipulate the data that is required to be shown in the table -------------------------- **/
  const ManipulatedData = () => {
    let Data = _.map(depoPersonel, (d) => {
      let temp = { ...d };
      if (d?.roles?.includes("Admin")) {
        temp["isAdmin"] = true;
      } else {
        temp["isAdmin"] = false;
        let depots = _.filter(d?.depots || [], (d) => d.hasAllocated);
        if (depots.length > 0) {
          temp["isAllocated"] = true;
        } else {
          temp["isAllocated"] = false;
        }
      }
      return temp;
    });
    return Data;
  };

  const handleOpen = () => setOpen(!open);

  /** Function executes when clicking on 'Edit Record' ------------------- **/
  const handleEditDepotPersonnelClick = async (data) => {
    setEditData(data);
    setOpen(true);
  };

  /** Function executes when clearing the search value. ---------------- **/
  const handleClearSearchText = () => {
    handleSearchInputChange({ target: { value: "" } });
  };

  /** Function to retrieve all depot users. --------------------- **/
  const getDepoPersonalData = async () => {
    setLoader(true);
    try {
      await dispatch(getAllDepotPerson()).unwrap();
      setLoader(false);
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
      setLoader(false);
    }
  };

  /** Function to retrieve all depot names associated with the depot manager -------------------- **/
  const getAllocatedToName = (data) => {
    let filteredArray = _.filter(data?.depots || [], (d) => d.hasAllocated);
    if (data?.roles.includes("Admin")) {
      return "Admin";
    } else if (data?.depots?.length > 0 && filteredArray.length > 0) {
      return filteredArray?.map((item) => item.name).join(" , ");
    } else {
      return "Inactive";
    }
  };

  /** Function executes when searching for depot users or depot personnel by first name or last name ----------------------- **/
  const handleSearchInputChange = (e) => {
    const searchText = e.target.value;
    setSearchValue(searchText);
    if (searchText === "") {
      setDepotPersonalShowData(depoPersonel);
    } else {
      const newFilter = depoPersonel.filter((value) => {
        return (
          value.firstName.toLowerCase().includes(searchText.toLowerCase()) ||
          value.lastName.toLowerCase().includes(searchText.toLowerCase())
        );
      });
      setDepotPersonalShowData(newFilter);
    }
  };

  /** Function executes when selecting a particular row from the table and sets it into the state. -------------------- **/
  const handleRowClick = (item) => {
    setSelectedRow(item);
    setShowViewRecordButton(!showViewRecordButton);
  };

  /** Function executes when clicking on the 'View Record' button -------------------- **/
  const handleViewRecordButtonClick = async () => {
    setIsEditFlag(true);
    setLoader(true);
    try {
      let data = await dispatch(getByIdDepotPersonal(selectedRow.id));
      setLoader(false);
      setSelectedRow(data?.payload || selectedRow);
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
      setLoader(false);
    }
  };

  /** Function to go back. ------------------------- **/
  const handleBackButtonClick = () => {
    setIsEditFlag(false);
    setSelectedRow({});
    getDepoPersonalData();
  };

  const handleDeactiveAccountClick = () => {
    setIsDeactivatedAccountFlag(true);
  };

  const handleUnlistAccountClick = () => {
    setIsUnlistAccountFlag(true);
  };

  const handleDeactivateAccountModalClose = () => {
    setIsDeactivatedAccountFlag(false);
    setIsDeactivateDepotInfo({});
  };

  const handleUnlistAccountModalClose = () => {
    setIsUnlistAccountFlag(false);
  };

  /** Function to handle image errors -------------------- **/
  const imgError = (image) => {
    image.onerror = "";
    image.src = "https://img.freepik.com/free-icon/user_318-563642.jpg";
    return true;
  }

  if (loader) {
    return <Loader />;
  }

  return (
    <>
      {!isEditFlag ? (
        <>
          <div className="row flex-row top-section-depots-personal-tab justify-content-between align-items-center mt-2">
            <div className="col-md-3" style={{ position: "relative" }}>
              <input
                style={{ position: "relative", width: "100%" }}
                className="search-input-for-depot-personal-tab"
                type="text"
                placeholder="Search by name..."
                value={searchValue}
                onChange={handleSearchInputChange}
              />
              {searchValue !== "" ? (
                <Close
                  style={{ cursor: "pointer" }}
                  onClick={handleClearSearchText}
                  className="search-icon-depotpersonal-style"
                />
              ) : (
                <Search className="search-icon-depotpersonal-style" />
              )}
            </div>
            <div className="col-md-9 ">
              <div className="row d-flex justify-content-end">
                <div className="d-flex show-admin-depot-personal-checkbox">
                  <Checkbox
                    checked={isAdmin}
                    onChange={({ target }) => {
                      setisAdmin(target.checked);
                      setIsActive(false);
                    }}
                  />
                  <InputLabel>SHOW ADMIN ONLY</InputLabel>
                </div>
                <div className="d-flex show-admin-depot-personal-checkbox">
                  <Checkbox
                    checked={IsActive}
                    onChange={({ target }) => {
                      setIsActive(target.checked);
                      setisAdmin(false);
                    }}
                  />
                  <InputLabel>SHOW INACTIVE ONLY</InputLabel>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`table-responsive ${depotPersonalShowData?.length < 10
              ? ""
              : "main-div-admin-depotpersonal-tab"
              } d-flex flex-column`}
          >
            <table
              className="table admintab-depots-personal-table table-borderless"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th scope="col" style={{ minWidth: "180px" }}>
                    NAME
                  </th>
                  <th scope="col" style={{ minWidth: "180px" }}>
                    EMAIL
                  </th>
                  <th scope="col" style={{ minWidth: "120px" }}>
                    PHONE
                  </th>
                  <th scope="col" style={{ minWidth: "300px" }}>
                    ALLOCATED TO
                  </th>
                  <th scope="col" style={{ minWidth: "100px" }}>
                    SINCE
                  </th>
                </tr>
              </thead>
              <tbody className="depotsperosnal-admin-tbl-body">
                {depotPersonalShowData && depotPersonalShowData.length > 0 ? (
                  _.orderBy(
                    depotPersonalShowData,
                    (d) => d.firstName.toLowerCase(),
                    ["asc"]
                  ).map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <tr
                          onClick={() => handleRowClick(item)}
                          className={`depottab-table-body-tr ${selectedRow.id == item.id ? "row-border" : ""
                            }`}
                        >
                          <td>
                            <img
                              src={item?.profileUrl || "https://img.freepik.com/free-icon/user_318-563642.jpg"}
                              onError={imgError}
                              alt="img"
                              width={25}
                              height={25}
                              className="me-1 depot-personel-list-img-style"
                            />
                            {item?.firstName} {item?.middleName}{" "}
                            {item?.lastName}
                          </td>
                          <td>{item.email}</td>
                          <td>{item.phoneNumber}</td>
                          <td
                            className={`${getAllocatedToName(item) == "Admin"
                              ? "add-blue-color-for-admin-flg"
                              : getAllocatedToName(item) == "Inactive"
                                ? "added-red-border-for-depot"
                                : ""
                              }`}
                          >
                            {getAllocatedToName(item)}
                          </td>
                          <td className="text-uppercase">
                            {moment(item.raisedOn).format("DD-MMM-YYYY") || ""}
                          </td>
                        </tr>
                        {showViewRecordButton && selectedRow.id == item.id && (
                          <tr className={`view-record-button`}>
                            <td>
                              <button
                                type="button"
                                className="text-uppercase view-button"
                                onClick={handleViewRecordButtonClick}
                              >
                                <i className="bi bi-eye-fill view-record-icon"></i>{" "}
                                View Record
                              </button>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      className="not-found-txt"
                      colSpan="5"
                      style={{ textAlign: "center" }}
                    >
                      No Records Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div
            style={{ height: 60, marginRight: 20 }}
            className="d-flex flex-row justify-content-end align-items-center"
          >
            <Button
              variant="outlined"
              className="btn-bootstrap-submit-style"
              startIcon={
                <img src={IconNewRecord} width={17} height={17} alt="new"></img>
              }
              type="submit"
              onClick={handleOpen}
            >
              ADD PERSONNEL
            </Button>
          </div>
        </>
      ) : (
        <DepotPersonalDetailView
          setAllocateTogle={() => {
            handleViewRecordButtonClick();
            setAllocateTogle(!allocateTogle);
          }}
          handleDeactiveAccountClick={handleDeactiveAccountClick}
          handleUnlistAccountClick={handleUnlistAccountClick}
          handleBackButtonClick={handleBackButtonClick}
          setEditTextFlag={setEditTextFlag}
          handleEditDepotPersonnelClick={handleEditDepotPersonnelClick}
          setIsDeactivateDepotInfo={setIsDeactivateDepotInfo}
          setIsFullDetails={setIsFullDetails}
        />
      )}

      <CommonModal togal={open} toggleHandler={handleOpen}>
        <AddDeportPersonalFrom
          handleViewRecordButtonClick={handleViewRecordButtonClick}
          setOpen={handleOpen}
          selectedData={selectedRow}
          setEditData={setEditData}
          editData={editData}
          setEditTextFlag={setEditTextFlag}
          editTextFlag={editTextFlag}
          isAdminParent={isAdmin}
        />
      </CommonModal>

      <CommonModal
        togal={isDeactivatedAccountFlag}
        toggleHandler={handleDeactivateAccountModalClose}
      >
        <DeactiveAccountForm
          setEditData={setEditData}
          getAllDepotPerson={async () => {
            dispatch(getByIdDepotPersonal(selectedRow.id));
          }}
          handleBackButtonClick={handleBackButtonClick}
          handleViewRecordButtonClick={handleViewRecordButtonClick}
          selectedData={selectedRow}
          handleDeactivateAccountModalClose={handleDeactivateAccountModalClose}
          isDeactivateDepotInfo={isDeactivateDepotInfo}
          isFullDetail={isFullDetail}
          setIsFullDetails={setIsFullDetails}
        />
      </CommonModal>

      <CommonModal
        togal={isUnlistAccountFlag}
        toggleHandler={handleUnlistAccountModalClose}
      >
        <UnlistAccountForm
          setEditData={setEditData}
          handleBackButtonClick={handleBackButtonClick}
          handleViewRecordButtonClick={handleViewRecordButtonClick}
          selectedData={selectedRow}
          handleUnlistAccountModalClose={handleUnlistAccountModalClose}
        />
      </CommonModal>

      <CommonModal togal={allocateTogle} toggleHandler={setAllocateTogle}>
        <AllocatToDepo
          handleViewRecordButtonClick={handleViewRecordButtonClick}
          selectedData={selectedRow}
          toggleHandler={setAllocateTogle}
        />
      </CommonModal>
    </>
  );
};
